import React, { useState, type ReactElement } from "react";
import Icon from "../../../../app/icon/Icon";
import { type User } from "../../../../store/slices/userSlice";
import { ACCESS_KEY, urlAPI, USER_ID_KEY } from "../../../../urls";
import QueryString from "qs";

interface IProps {
    user: User
}
type ContactOverride = { email?: string; phone?: string }

export default function AgentProfileContactInfo({ user }: IProps): ReactElement {
    const [contactsLoading, setContactsLoading] = useState(false)
    const [contactOverride, setContactOverride] = useState<ContactOverride>({})
    const userID = window.localStorage.getItem(USER_ID_KEY)

    const email = contactOverride.email ?? user?.email ?? ''
    const phone = contactOverride.phone ?? user?.phone ?? ''

    const fetchContacts = async (): Promise<void> => {
        if (contactsLoading || !user?.id) return
        setContactsLoading(true)
        try {
            const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''

            const query = QueryString.stringify(
                { fields: ['email', 'phone'] },
                { encodeValuesOnly: true }
            )

            const bodyObject = {
                method: 'GET' as const,
                collection: 'users',
                id: Number(user.id),
                query
            }

            const resp = await fetch(urlAPI, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwt}`
                },
                body: JSON.stringify(bodyObject)
            })

            const json = await resp.json()

            if (json?.success === true && json?.response != null) {
                const payload =
                    json.response?.data?.attributes ??
                    json.response?.attributes ??
                    json.response

                const nextEmail: string | undefined =
                    payload?.email ?? payload?.Email ?? undefined
                const nextPhone: string | undefined =
                    payload?.phone ?? payload?.Phone ?? undefined

                setContactOverride({
                    email: nextEmail ?? '',
                    phone: nextPhone ?? ''
                })
            } else {
                console.warn('Failed to fetch contacts:', json?.response?.error)
            }
        } catch (e) {
            console.error('fetchContacts error', e)
        } finally {
            setContactsLoading(false)
        }
    }

    return (
        <div className="card shadow-sm mb-4 mx-4">
            <div className="card-body p-4">
                <div className="border border-gray-300 border-dashed rounded py-3 px-4 w-100 g-0">
                    <div className="fs-2 fw-bold counted">Contact info</div>
                    <div className="row">
                        <div className={'col-9 fw-semibold fs-6 text-gray-600'}>
                            <div>Email :</div>
                            <div>Phone :</div>
                        </div>
                        <div className={'col-3 fw-semibold fs-6 text-gray-600 d-flex flex-column align-items-end text-nowrap'}>
                            <a href={email ? `mailto:${email}` : undefined}>
                                <Icon name={'mail'} /> {email || '—'}
                            </a>
                            <a href={phone ? `tel:${phone}` : undefined}>
                                <Icon name={'call'} /> {phone || '—'}
                            </a>
                        </div>
                    </div>
                </div>

                {Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID) && (
                    <div className={'row'}>
                        <div className={'col mt-4'}>
                            <div
                                className={'btn btn-bso'}
                                onClick={() => { void fetchContacts() }}
                            >
                                {contactsLoading ? (
                                    <span className="spinner-border spinner-border-sm me-2" />
                                ) : null}
                                Get client details
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}